export const ExpectedQueryParamsConfig = Object.freeze({
  keycloakCode: {
    code: 'code',
    state: 'state',
  },
  trazabilityCode: 'trazabilityCode',
  ticketId: 'ticketId',
});
